import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { GoogleSignInButton } from '../components/GoogleSignInButton';
import { toast } from 'sonner';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const result = await login(email, password);
    setLoading(false);
    
    if (result.success) {
      toast.success('Welcome back!');
      navigate('/dashboard');
    } else {
      toast.error(result.error);
    }
  };

  return (
    <div className="min-h-screen bg-[#F9F7F3] flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/">
            <h1 className="text-3xl font-light tracking-tight mb-2" style={{fontFamily: 'Spectral, serif'}}>Stable Stationary</h1>
          </Link>
          <p className="text-sm text-[#737373]">Welcome back</p>
        </div>

        <div className="bg-white border border-[#E5E0D8] rounded-md p-8 shadow-[2px_2px_0px_rgba(26,26,26,0.08)]">
          <div className="pt-2">
            <GoogleSignInButton label="Continue with Google" testId="login-google-btn" variant="promoted" />
          </div>

          <div className="my-6 flex items-center gap-3">
            <div className="flex-1 h-px bg-[#E5E0D8]" />
            <span className="text-xs uppercase tracking-widest text-[#737373]">or use email</span>
            <div className="flex-1 h-px bg-[#E5E0D8]" />
          </div>

          <form onSubmit={handleSubmit} data-testid="login-form">
            <div className="space-y-4">
              <div>
                <Label htmlFor="email" className="label-text">Email</Label>
                <Input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="mt-2 border-[#E5E0D8] focus:ring-[#B94A3E]"
                  data-testid="login-email-input"
                />
              </div>
              <div>
                <Label htmlFor="password" className="label-text">Password</Label>
                <Input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="mt-2 border-[#E5E0D8] focus:ring-[#B94A3E]"
                  data-testid="login-password-input"
                />
                <div className="mt-2 text-right">
                  <Link to="/forgot-password" className="text-xs text-[#B94A3E] hover:underline" data-testid="login-forgot-link">
                    Forgot password?
                  </Link>
                </div>
              </div>
              <Button
                type="submit"
                className="w-full bg-[#B94A3E] hover:bg-[#9d3e33] text-white"
                disabled={loading}
                data-testid="login-submit-btn"
              >
                {loading ? 'Signing in...' : 'Sign In'}
              </Button>
            </div>
          </form>

          <div className="mt-6 text-center text-sm">
            <p className="text-[#737373]">
              Don't have an account?{' '}
              <Link to="/signup" className="text-[#B94A3E] hover:underline" data-testid="login-signup-link">
                Sign up
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
